// Velden die een klant bij "Opnieuw indienen" mag terugsturen naar
// PUT /application/update/:id. De server-Joi weigert alles wat hier niet in
// staat ("... is not allowed"), dus de formulieren vullen alleen deze keys
// voor uit de opgehaalde aanvraag. Interne velden die de server erbij zet
// (billingMode, partnerInvoice, machtiging, issueKey, previousKeys, ...)
// horen hier bewust NIET in.
export const APPLICATION_FORM_FIELDS = [
  "KvkNummer",
  "rechtsvorm",
  "uitgebreideRechtsvorm",
  "rsin",
  "bsn",
  "VoorLetters",
  "geslacht",
  "postCode",
  "straatNaam",
  "email",
  "Kenmerk",
  "aantekeningVoorOns",
  "handelsNaam",
  "achterNaam",
  "huisNummer",
  "plaats",
  "teleFoonNummer",
  "datumOpdrachtBevestiging",
  // EIA Zon
  "aantalZonnepanelen",
  "totaalVermogen",
  // ISDE
  "type",
  "annualStatement",
];

/** Zet alleen de formuliervelden uit een aanvraag in react-hook-form. */
export const prefillApplicationForm = (data, setValue) => {
  APPLICATION_FORM_FIELDS.forEach((key) => {
    if (data?.[key] !== undefined && data?.[key] !== null) setValue(key, data[key]);
  });
};
